<dialogtitle title="Attach Document/Images"></dialogtitle>
<mat-dialog-content>
  <div class="upload-container">

    <div class="attachment-container" appDnd (fileDropped)="onFileDropped($event)">
      <input class="input" type="file"  #fileDropRef id="fileDropRef" multiple 
        (change)="fileBrowseHandler($event.target.files); fileDropRef.value=''" />
      <img class="dst-icon common-img-icon cloud" src="assets/images/file-upload.svg" alt="" />
      <br><br>
      <h3>
        <p>Drag and drop file here</p>
        <p>or</p>
      </h3>
      <br>
      <label class="label" for="fileDropRef">Browse</label>
    </div>

    <div class="files-list" fxLayout="row" fxLayoutGap="10px" *ngIf="showDescription">
      <div fxLayout="column" fxFlex="50" *ngIf="files.length">
        <label>File Name<span class="flag-required">*</span></label>
        <div class="single-file" *ngFor="let file of files; let i = index">
          <div class="file-icon">
            <img class="dst-icon common-img-icon" src="assets/images/file-excel.svg" alt="" />
          </div>
          <div class="info">
            <h4 class="name">{{file?.name}}</h4>
            <div class="progress-cont">
              <div class="progress" [style.width]="file?.progress + '%'"></div>
            </div>
          </div>
          <div class="delete" (click)="onDeleteFile(i)">
            <img alt="close-blue" src="assets/images/close-blue.svg" />
          </div>
        </div>
        <br>
      </div>
      <div fxLayout="column" fxFlex="50" *ngIf="files.length">
        <label> Description</label>
        <div class="description" *ngFor="let file of files; let i = index">
        <input class="common-text-box" type="text" [(ngModel)]="file.description" placeholder="Enter" maxlength="100" />
        </div>
        <br>
      </div>
    </div>

    <div class="files-list" *ngIf="!showDescription">
      <div class="single-file" *ngFor="let file of files; let i = index">
        <div class="file-icon">
          <img class="dst-icon common-img-icon" src="assets/images/file-excel.svg" alt="" />
        </div>
        <div class="info">
          <h4 class="name">{{file?.name}}</h4>
          <div class="progress-cont">
            <div class="progress" [style.width]="file?.progress + '%'"></div>
          </div>
        </div>
        <div class="delete" (click)="onDeleteFile(i)">
          <img alt="close-blue" src="assets/images/close-blue.svg" />
        </div>
      </div>
    </div>

    <div class="nr-mat-error" fxLayout="row" *ngIf="fileSize">
      Maximum file size allowed is 15Mb.
    </div>

  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="common-button-group" fxLayoutAlign="center center" fxLayoutGap="10px">
    <button class="common-button nr-button-cancel" type="button" (click)="onCancel()"> Cancel </button>
    <button class="common-button nr-button-active" type="button" (click)="onDroppedFile(files)"
      [disabled]="!isDisabled">
      Save
    </button>
  </div>
</mat-dialog-actions>